import { Button, Form, Input, List, Skeleton, Space } from "antd"
import { useEffect, useState } from "react"
import { SystemDescriptions } from "src/common/descriptions"
import { Col24 } from "src/components/Columns"
import { FormActionButtons } from "src/components/FormActionButtons"

interface Props {
    onCancel: VoidFunction
    onAccept: (characteristics: string[]) => void
    initialValues?: string[]
    clean?: boolean
    acceptOnChange?: boolean
}

export const CharacteristicsForm = (props: Props) => {
    const [currentCharacteristic, setCurrentCharacteristic] = useState<string>('')
    const [characteristics, setCharacteristics] = useState<string[]>([])
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true)

    useEffect(() => {
        if (props.initialValues) {
            setCharacteristics(props.initialValues)
        }
    }, [props.initialValues])

    useEffect(() => {
        if (props.acceptOnChange && !isFirstTime) {
            props.onAccept(characteristics)
        } else {
            setIsFirstTime(false)
        }
    }, [characteristics])

    const descriptions = SystemDescriptions.PAGES.SERVICE.CREATE

    const removeCharacteristic = (indexToRemove: number) => {
        const currentCharacteristics = [...characteristics]

        if (indexToRemove >= 0 && indexToRemove < currentCharacteristics.length) {
            currentCharacteristics.splice(indexToRemove, 1);
        }

        setCharacteristics(currentCharacteristics)
    }

    return (
        <>
            <Col24>
                <>
                    <Form.Item
                        label={props.acceptOnChange ? "" : descriptions.FORM.CHARACTERISTICS.LABEL}
                        name={"characteristic"}
                        validateTrigger="onBlur"
                    >
                        <Space.Compact style={{ width: '100%' }}>
                            <Input
                                placeholder={descriptions.FORM.CHARACTERISTICS.PLACEHOLDER}
                                onChange={(e) => {
                                    setCurrentCharacteristic(e.target.value)
                                }}
                                value={currentCharacteristic}
                            />
                            <Button
                                onClick={() => {
                                    if (!currentCharacteristic || currentCharacteristic.length === 0) {
                                        return
                                    }

                                    setCharacteristics([
                                        ...characteristics,
                                        currentCharacteristic,
                                    ])

                                    setCurrentCharacteristic('')
                                }}
                                type="primary">
                                {descriptions.ADD}
                            </Button>
                        </Space.Compact>
                    </Form.Item>
                    <List
                        className="demo-loadmore-list"
                        itemLayout="horizontal"
                        dataSource={characteristics}
                        size="small"
                        renderItem={(item, idx) => (
                            <List.Item
                                style={{ paddingLeft: 0, paddingRight: 0 }}
                                actions={[
                                    <Button
                                        color="danger"
                                        variant="solid"
                                        size="small"
                                        onClick={() => removeCharacteristic(idx)}
                                        key="list-loadmore-edit"
                                    >
                                        {descriptions.REMOVE}
                                    </Button>,
                                ]}
                            >
                                <Skeleton avatar title={false} active loading={false}>
                                    <div>{item}</div>
                                </Skeleton>
                            </List.Item>
                        )}
                        style={{
                            marginBottom: 24,
                        }}
                    />
                </>
            </Col24>
            {
                !props.acceptOnChange &&
                <Col24>
                    <FormActionButtons
                        cancelText={descriptions.CANCEL_BUTTON}
                        actionText={descriptions.SAVE_BUTTON}
                        onCancel={() => {
                            setCharacteristics([])
                            props.onCancel()
                        }}
                        onAccept={() => {
                            props.onAccept(characteristics)
                        }}
                    />
                </Col24>
            }
        </>
    )
}
